import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import logo from "../../assets/logo_final.png";

export default function IntroLoader({ onFinish }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onFinish(); // notify parent
    }, 2500); // total animation time

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-white z-[9999] flex items-center justify-center">
      <motion.img
        src={logo} // place logo in public folder
        alt="Logo"
        initial={{ x: "-100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{
          duration: 1.5,
          ease: "easeInOut",
        }}
        className="w-[280px] md:w-[350px]"
      />
    </div>
  );
}